import { useState } from "react"

const useAppState = () => {
  const [language, setLanguage] = useState('en')
  const initialStateInsured = {
    name: '',
    nricPassport: '',
    bizRegNo: '',
    newSSMId: '',
    dateOfBirth: '',
    insuredAge: '',
    gender: '',
    email: '',
    confirmEmail: '',
    mobile: '',
    marital: '',
    address1: '',
    address2: '',
    address3: '',
    postcode: '',
    city: '',
    addState: '',
    type: 'P',
    occpCode: '',
    typeOfBusiness: '',
    nationality: '',
    isNric: false
  }
  const [insured, setInsured] = useState(initialStateInsured);
  // const reduceInsured = state => {
  //   const { nricPassport } = state

  //   console.log(`nricPassport passed: ${nricPassport}`)

  //   let dateOfBirth = state.dateOfBirth || insured.dateOfBirth
  //   let gender = state.gender || insured.gender
  //   let isNric = insured.isNric
  //   let nationality = state.nationality || insured.nationality
  //   if (nricPassport) {
  //     const strippedNric = nricPassport.replace(/-/g, '')
  //     if (strippedNric.length === 12 && /^\d+$/.test(strippedNric)) {
  //       isNric = true
  //       const baseYear = 1900
  //       const currentYear = new Date().getFullYear()
  //       const maxAge = 90
  //       let year = baseYear + parseInt(nricPassport.substr(0, 2))
  //       if (currentYear - year >= maxAge) year += 100
  //       const month = parseInt(nricPassport.substr(2, 2))
  //       const day = parseInt(nricPassport.substr(4, 2))
  //       dateOfBirth = new Date(year, month - 1, day)
  //       if (!state.gender) {
  //         const lastDigitNric = parseInt(nricPassport.substr(-1))
  //         gender = lastDigitNric % 2 === 0 ? 'F' : 'M'
  //       }
  //       nationality = 'MYS'
  //     }
  //   }

  //   setInsured((prev) => ({
  //     ...prev,
  //     ...state,
  //     nricPassport,
  //     dateOfBirth,
  //     gender,
  //     nationality,
  //     isNric
  //   }))
  // }

  const reduceInsured = (state = {}) => {
    setInsured(prev => {
      const nricPassport = state.nricPassport ?? prev.nricPassport;

      console.log(`nricPassport used: ${nricPassport}`);

      let dateOfBirth = state.dateOfBirth || prev.dateOfBirth;
      let gender = state.gender || prev.gender;
      let isNric = prev.isNric;
      let nationality = state.nationality || prev.nationality;
      let insuredAge = state.insuredAge || prev.insuredAge;
      if (nricPassport) {
        const strippedNric = nricPassport.replace(/-/g, '');
        if (strippedNric.length === 12 && /^\d+$/.test(strippedNric)) {
          isNric = true;
          const baseYear = 1900;
          const currentYear = new Date().getFullYear();
          const maxAge = 90;
          let year = baseYear + parseInt(nricPassport.substr(0, 2));
          if (currentYear - year >= maxAge) year += 100;
          const month = parseInt(nricPassport.substr(2, 2));
          const day = parseInt(nricPassport.substr(4, 2));
          dateOfBirth = new Date(year, month - 1, day);
          insuredAge = currentYear - dateOfBirth.getFullYear();
          if (!state.gender && !prev.gender) {
            const lastDigitNric = parseInt(nricPassport.substr(-1));
            gender = lastDigitNric % 2 === 0 ? 'F' : 'M';
          }

          nationality = 'MYS';
        }
      }

      return {
        ...prev,
        ...state,
        dateOfBirth,
        insuredAge,
        gender,
        nationality,
        isNric,
        nricPassport, // ensure NRIC persists
      };
    });
  };
  const initialStateVehicle = {
    vehicleNumber: '',
    year: '',
    make: '',
    model: '',
    makeModel: "",
    variants: [],
    seat: 0,
    // variant: {},
    nvic: '',
    engineNo: '',
    chassisNo: '',
    cc: '',
    region: '',
    useOfVehicle: '',
    sumInsured: 0,
    sumInsuredOptions: [],
    financing: '4', // N/A default value
    loanCompany: '516', // Loan Company Default Value
    claimsAtFault: 0,
    windscreenClaims: 0,
    allowWindscreen: "Y",
    odometer: 0,
    availableNvics: []
  }
  const [vehicle, setVehicle] = useState(initialStateVehicle)
  const initialStateQuote = {
    product: { value: 'smc', label: 'SOMPO MotorNow' },
    coverageType: 'smc',
    basicPremium: 0,
    ncdPercent: 0,
    ncdAmount: 0,
    totalBasePremium: 0,
    grossPremium: 0,
    rebatePercent: 10,
    rebateAmount: 0,
    sstPercent: 0,
    sstAmount: 0,
    stampDuty: 0,
    totalPremium: 0,
    inceptionDate: '',
    expiryDate: '',
    extraCoverageAmount: 0,
    selectedCoverageAmount: 0,
    covernoteNo: '',
    partner: '',
    transactionReferenceNumber: '',
    renewalNo: '',
  }
  const [quotation, setQuotation] = useState(initialStateQuote)

  const [smcSumInsured, setSmcSumInsured] = useState("100")
  const [normalTotalPremium, setNormalTotalPremium] = useState(0)
  const [excessTotalPremium, setExcessTotalPremium] = useState(0)
  const [tpftTotalPremium, setTpftTotalPremium] = useState(0)
  const [tpBundleTotalPremium, setTpBundleTotalPremium] = useState(0);
  const [compBundleTotalPremium, setCompBundleTotalPremium] = useState(0);

  // msafe plans:
  // PL01
  // PL02
  // PL03
  const [msafePlan, setMsafePlan] = useState("PL01")
  const [msafePicLink, setMsafePicLink] = useState("")
  const [msafePicName, setMsafePicName] = useState("")
  const [msafeFile, setMsafeFile] = useState("")
  const [msafeFileUrl, setMsafeFileUrl] = useState("")
  const [msafeQuotation, setMsafeQuotation] = useState({
    sumInsured: 0,
    isAgreedValue: false
  })
  const [smcAgreedVal, setSmcAgreedVal] = useState(false)

  const [motorNowSumInsured, setMotorNowSumInsured] = useState(0)

  const [isQuotationRefreshed, setIsQuotationRefreshed] = useState(true)

  const [sumInsureds, setSumInsureds] = useState([])
  const [sumInsuredsMsafe, setSumInsuredsMsafe] = useState([])
  const [addons, setAddons] = useState([
    {
      CODE: "89A",
      SUM_INSURED: 1000,
      PREMIUM: "50"
    },
    {
      CODE: "TOWM",
      PREMIUM: "50"
    },
    {
      CODE: "57",
      PREMIUM: "50"
    },
    {
      CODE: "112",
      PREMIUM: "50",
      CART_DAYS: 7,
      CART_AMOUNT: 50
    },
    {
      CODE: "PLC",
      PREMIUM: "50"
    },
    {
      CODE: "72",
      PREMIUM: "50"
    },
    {
      CODE: "EHRP",
      PREMIUM: "50"
    },
    {
      CODE: "111",
      PREMIUM: "50"
    },
    {
      CODE: "BTWP",
      PREMIUM: "50"
    },
    {
      CODE: "97",
      SUM_INSURED: 1000,
      PREMIUM: "50"
    },
    {
      CODE: "25",
      PREMIUM: "50"
    },
  ])
  const [cart, setCart] = useState("750")
  const [paPlan, setPAPlan] = useState("PA1M")
  const [paSumInsured, setPaSumInsured] = useState(5000)

  const [isRecentlyLapsed, setIsRecentlyLapsed] = useState(false)
  const [isLapsedPurchase, setIsLapsedPurchase] = useState(false)
  const [isCurrentTP, setIsCurrentTP] = useState(false)
  const [isSmcAvail, setIsSmcAvail] = useState(false)
  // isMSafeAvail - To Control Multiple Plan Display
  const [isMSafeAvail, setIsMSafeAvail] = useState(false)
  const [selectedAddons, setSelectedAddons] = useState([])
  const [isUpsellSelected, setIsUpsellSelected] = useState(false)
  const [showUpsellModal, setShowUpsellModal] = useState(false)
  const [detailPolicyData, setDetailPolicyData] = useState(null)
  const [isAddonsLoad, setIsAddonsLoad] = useState(false)
  const [isTpftLoading, setisTpftLoading] = useState(false)
  const [isMSafeLoad, setIsMSafeLoad] = useState(false)
  const [showResults, setShowResults] = useState(false)
  const [corAddress, setCorAddress] = useState(false)
  const [contactNo, setContactNo] = useState(false)
  const [occp, setOccp] = useState(false)
  const [promoCode, setPromoCode] = useState('')
  const [paymentId, setPaymentId] = useState(0)

  // For Plan Header Navigation Purpose
  const [coveragePageActive, setCoveragePageActive] = useState(false)
  const [planPageActive, setPlanPageActive] = useState(false)
  const [detailPageActive, setDetailPageActive] = useState(false)
  const [showMaintenance, setShowMaintenance] = useState({ title: "", message: "" });
  const handleVehicle = ({ make, model }) => {
    let state = {}
    if (make !== vehicle.make) {
      state.make = make
      state.model = ''
    }
    setVehicle({
      ...vehicle,
      ...state
    })
  }

  const reduceVehicle = state => {
    setVehicle(prevState => ({
      ...prevState,
      ...state,
    }))
  }
  const reduceQuotation = state => {
    setQuotation({
      ...quotation,
      ...state
    })
  }
  const [getRenewal, setGetRenewal] = useState(false)
  const [isRenewal, setIsRenewal] = useState(false)
  const [otpEmail, setOtpEmail] = useState('')
  const [otpMobile, setOtpMobile] = useState('')
  const [resetQuote, setResetQuote] = useState(true)
  const [quotationPayload, setQuotationPayload] = useState(null)

  // SOMPO Motorcycle Bundle Initiative
  const [isCompBundleEligible, setIsCompBundleEligible] = useState(false)
  const [isTpBundleEligible, setIsTpBundleEligible] = useState(false)
  const [selectedBundle, setSelectedBundle] = useState(null);

  return {
    insured,
    setInsured: reduceInsured,
    vehicle,
    setVehicle: reduceVehicle,
    handleVehicle,
    quotation,
    setQuotation: reduceQuotation,
    normalTotalPremium,
    setNormalTotalPremium,
    excessTotalPremium,
    setExcessTotalPremium,
    tpftTotalPremium,
    setTpftTotalPremium,
    isQuotationRefreshed,
    setIsQuotationRefreshed,
    sumInsureds,
    setSumInsureds,
    sumInsuredsMsafe,
    setSumInsuredsMsafe,
    addons,
    setAddons: setAddons,
    selectedAddons,
    setSelectedAddons,
    cart,
    setCart,
    isRecentlyLapsed,
    setIsRecentlyLapsed,
    isLapsedPurchase,
    setIsLapsedPurchase,
    isCurrentTP,
    setIsCurrentTP,
    isAddonsLoad,
    setIsAddonsLoad,
    isTpftLoading,
    setisTpftLoading,
    showResults,
    setShowResults,
    corAddress,
    setCorAddress,
    contactNo,
    setContactNo,
    occp,
    setOccp,
    promoCode,
    setPromoCode,
    paPlan,
    setPAPlan,
    paymentId,
    setPaymentId,
    getRenewal,
    setGetRenewal,
    isRenewal,
    setIsRenewal,
    isMSafeLoad,
    setIsMSafeLoad,
    msafePlan,
    setMsafePlan,
    msafePicLink,
    setMsafePicLink,
    msafePicName,
    setMsafePicName,
    msafeFile,
    setMsafeFile,
    msafeQuotation,
    setMsafeQuotation,
    motorNowSumInsured,
    setMotorNowSumInsured,
    language,
    setLanguage,
    isMSafeAvail,
    setIsMSafeAvail,
    initialStateInsured,
    initialStateQuote,
    initialStateVehicle,
    coveragePageActive,
    setCoveragePageActive,
    msafeFileUrl,
    setMsafeFileUrl,
    showMaintenance,
    setShowMaintenance,
    planPageActive,
    setPlanPageActive,
    detailPageActive,
    setDetailPageActive,
    isSmcAvail,
    setIsSmcAvail,
    paSumInsured,
    setPaSumInsured,
    smcSumInsured,
    setSmcSumInsured,
    smcAgreedVal,
    setSmcAgreedVal,
    resetQuote,
    setResetQuote,
    otpEmail,
    setOtpEmail,
    otpMobile,
    setOtpMobile,
    quotationPayload,
    setQuotationPayload,
    isUpsellSelected,
    setIsUpsellSelected,
    showUpsellModal,
    setShowUpsellModal,
    detailPolicyData,
    setDetailPolicyData,
    isCompBundleEligible,
    setIsCompBundleEligible,
    isTpBundleEligible,
    setIsTpBundleEligible,
    selectedBundle,
    setSelectedBundle,
    tpBundleTotalPremium,
    setTpBundleTotalPremium,
    compBundleTotalPremium,
    setCompBundleTotalPremium
  }
}

export default useAppState